export function getColor(name: string): string | undefined {
    name = name.toLowerCase().replace(/[^a-z]/g, '');

    const context = document.createElement('canvas').getContext('2d');

    context!.fillStyle = name;

    return context!.fillStyle;
}
